module.exports = __webpack_public_path__ + "static/img/02.631e753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/02.jpg
// module id = GPFi
// module chunks = 0